
// import { useEffect } from "react";
import Image from "next/image";
import Icon from "@/assets/icon.png";
import Title from "../Title";


const FeaturesSection = ({ data, loading }) => {
  // Media URL helper
  const getMediaUrl = (media) => {
    const baseUrl = process.env.NEXT_PUBLIC_STRAPI_URL || "http://localhost:1337";
    const url = media?.url || media?.data?.attributes?.url || media?.data?.url;
    if (!url) return null;
    if (url.startsWith("http")) return url;
    return `${baseUrl}${url}`;
  };

  // Rich Text helper for Strapi Blocks
  const renderRichText = (blocks) => {
    if (typeof blocks === 'string') return blocks;
    if (Array.isArray(blocks)) {
      return blocks.map(block => {
        if (block.type === 'paragraph') {
          return block.children.map(child => child.text).join('');
        }
        return '';
      }).join('\n');
    }
    return '';
  };

  const heading = data?.Title || "Redefining Higher Education for India’s Next Generation of Achievers";
  const subText = data?.Description || "We integrate academic excellence with industry-aligned skill development to prepare students for real-world careers.";

  const features = data?.Features_Blocks?.map(block => ({
    icon: getMediaUrl(block?.Icon) || Icon,
    title: block?.Feature_title,
    text: renderRichText(block?.Feature_Description)
  })) || [];

  if (loading && !data) {
    return (
      <section className="top_bottom_space w-full">
        <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
          <div className="animate-pulse flex flex-col space-y-4">
            <div className="h-8 bg-gray-200 rounded w-3/4" />
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-5/6" />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="top_bottom_space w-full">
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        <div className="w-full heading_space_bottom">
          <Title
            heading={heading}
            subText={subText}
            color="text-black"
            subTextColor="text-black/70"
            align="text-left"
          />
        </div>
      </div>

      <div className="w-full bg-cover bg-center" style={{
        backgroundImage: ` url('/bg.svg')`
      }}>
        <div className="relative max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)] text-white py-16"
        >
          <div className="w-full mx-auto">
            {/* Mobile: horizontal slider to reduce vertical scroll */}
            <div className="sm:hidden">
              <div className="flex space-x-4 overflow-x-auto snap-x snap-mandatory -mx-4 px-4">
                {features.map((item, i) => (
                  <div
                    key={i}
                    className={`snap-center flex-shrink-0 w-[85%] sm:w-auto flex flex-col items-start justify-start space-y-4 relative bg-white/5 backdrop-blur-md rounded-xl p-6 shadow-lg border border-white/10`}
                  >
                    <div className="flex items-start justify-start w-15 h-15">
                      <Image src={item.icon} alt={typeof item.title === 'string' ? item.title : 'feature-icon'} width={60} height={60} />
                    </div>

                    <div className="text-left">
                      <h3 className="font-bold text-[20px] mb-2">{item.title}</h3>
                      <p className="text-[16px] text-[#FFFFFF]">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Desktop / Tablet: grid layout (unchanged) */}
            <div className="hidden sm:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-left my-2 md:my-5">
              {features.map((item, i) => (
                <div
                  key={i}
                  className={`flex flex-col items-start justify-start space-y-4  relative
                ${i === 1 || i === 2 || i === 3 ? "lg:border-l-2 pl-0 md:pl-0 lg:pl-10 lg:border-white/10" : "pl-0"}
              `}
                >

                  <div className="flex items-start justify-start w-15 h-15">
                    <Image src={item.icon} alt={typeof item.title === 'string' ? item.title : 'feature-icon'} width={60} height={60} />
                  </div>

                  <div className="text-left">
                    <h3 className="font-bold text-[20px] mb-2">{item.title}</h3>
                    <p className="text-[16px] text-[#FFFFFF]">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default FeaturesSection;
